import { render } from "./BlockedUsersPage.vue?vue&type=template&id=087ffe13&scoped=true"
import script from "./BlockedUsersPage.vue?vue&type=script&lang=js"
export * from "./BlockedUsersPage.vue?vue&type=script&lang=js"

import "./BlockedUsersPage.vue?vue&type=style&index=0&id=087ffe13&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-087ffe13"]])

export default __exports__